// console.log('env value is ', process.env);
export const client_id =
    process.env.VUE_APP_TRUELAYER_ENV === 'development' ? 'sandbox-clarityrdtest-8f8e26' : 'clarityglobal-13a88c';

export const redirect_uri = window.location.origin + '/investments/openbanking';

const truelayer_base_url =
    process.env.VUE_APP_TRUELAYER_ENV === 'development'
        ? 'https://auth.truelayer-sandbox.com/'
        : 'https://auth.truelayer.com/';

export const authentication_link =
    truelayer_base_url +
    '?response_type=code&client_id=' +
    client_id +
    '&scope=accounts%20balance%20cards%20direct_debits%20info%20offline_access%20standing_orders%20transactions&redirect_uri=' +
    redirect_uri +
    '&providers=uk-cs-mock%20uk-ob-all%20uk-oauth-all';
